import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Filter } from '@shared/models/filter';
import { ApiEndpoint } from '@shared/shared/enums/api-endpoints.enum';
import { IArticle, IArticles } from '@shared/shared/interfaces/article.interfaces';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as ArticlesActions from './articles.actions';

@Injectable()
export class ArticlesEffects {
  constructor(private actions$: Actions, private http: HttpClient, private router: Router) {}

  public getAllArticles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ArticlesActions.GET_ALL_ARTICLES),
      switchMap((action: ArticlesActions.GetAllArticles) => {
        let tag = '?';

        tag += action.payload.page ? `page=${action.payload.page}` : '';
        tag += action.payload.tagModule ? `&tag_module=${action.payload.tagModule}` : '';
        tag += action.payload.pageSize ? `&page_size=${action.payload.pageSize}` : '';
        tag += action.payload.filters
          ? action.payload.filters.map((filter: Filter) => `&${filter.name}=${filter.value}`).join('')
          : '';

        return this.http.get<IArticles>(`${ApiEndpoint.ARTICLES}${tag}`).pipe(
          map((articles) => new ArticlesActions.GetAllArticlesSuccess(articles)),
          catchError((error) => of(new ArticlesActions.GetAllArticlesFail(error)))
        );
      })
    )
  );

  public getArticle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ArticlesActions.VIEW_ARTICLE),
      switchMap((action: ArticlesActions.ViewArticle) => {
        return this.http.get<IArticle>(`${ApiEndpoint.ARTICLES}${action.payload}`).pipe(
          map((article) => new ArticlesActions.ViewArticleSuccess(article)),
          catchError((error) => {
            this.router.navigate(['/error/not-found']);
            return of(new ArticlesActions.ViewArticleFail(error));
          })
        );
      })
    )
  );
}

export const articlesEffects: any[] = [ArticlesEffects];
